import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var definitionListDescription = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_1uk2fnd0',variantClassNames:{monospace:{true:'fx_2d2fb1e5_1uk2fnd1',false:'fx_2d2fb1e5_1uk2fnd2'}},defaultVariants:{monospace:false},compoundVariants:[]});

export { definitionListDescription };
//# sourceMappingURL=definitionListDescription.vanilla.mjs.map
